// extracted by mini-css-extract-plugin
module.exports = {"Container":"Navbar_Container__1MqrG","Open":"Navbar_Open__2fR5X","LanguageSwitcher":"Navbar_LanguageSwitcher__12Zvj","CloseBtn":"Navbar_CloseBtn__3Ukvq","Nav":"Navbar_Nav__1hmbJ"};